import React from "react";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useEmployeeType } from "../../hooks/useEmployeeType";
import EmployeeTypeModule from "../../components/modules/EmployeeType/EmployeeTypeModule";

const EmployeeTypePage = ({ user, isHideSideMenu }) => {
  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();
  const logic = useEmployeeType({ user, showGeneralMessage });

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl">
            <div className="mainteHeader">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Maintenance > "}</span>
                <span style={{ borderBottom: "1px solid black" }}>{"Employee Type"}</span>
              </div>
              <h3>Employee Type</h3>
            </div>
            <EmployeeTypeModule user={user} {...logic} />
          </div>
        </div>
      </div>

      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
      <LoadingSpinner loading={logic.loading} />
    </>
  );
};

export default EmployeeTypePage;